"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcreditcardvertical = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 52 57",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcreditcardvertical` : '') + (description ? ` desc-brandedcreditcardvertical` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcreditcardvertical"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcreditcardvertical"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.78.05c.88-.22 1.77.3 2 1.18l11.97 45.45c.23.88-.29 1.77-1.17 2.01l-28.56 7.52c-.88.22-1.77-.3-2-1.17L.06 9.58a1.64 1.64 0 0 1 1.17-2L29.78.04Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m4.67 6.66 8.3-2.13 12.81 48.63-8.3 2.14L4.66 6.66Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.36 5.77c.9 0 1.64.74 1.64 1.64v47.01c0 .9-.73 1.64-1.64 1.64H20.83c-.9 0-1.64-.73-1.64-1.64v-47c0-.91.73-1.65 1.64-1.65h29.53Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.25 12.67h-3.83c-.6 0-1.09.5-1.09 1.12v4.76c0 .62.49 1.12 1.09 1.12h3.83c.6 0 1.08-.5 1.08-1.12v-4.76a1.1 1.1 0 0 0-1.08-1.12Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.83 56.06h29.53c.9 0 1.64-.73 1.64-1.64v-36.7A94.82 94.82 0 0 1 19.2 49.4v5.03c0 .91.73 1.64 1.64 1.64h-.01Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.66 40.08h-.1v4.4h.1v-4.4Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.67 43.63v-.22h.21c.1 0 .17.04.17.12 0 .08-.09.12-.14.13.05 0 .15.04.15.13 0 .1-.1.15-.2.15h-.2v-.32Zm.16-.18h-.03v.2h.04a.1.1 0 0 0 .1-.1c0-.06-.03-.1-.1-.1Zm0 .24h-.04v.2h.05c.04 0 .09-.03.09-.1s-.04-.1-.1-.1Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m28.9 43.63-.01-.22h.32v.07H29v.16h.2v.06H29v.19h.2v.06h-.33v-.32h.01Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.5 43.94h-.16a.76.76 0 0 0-.06-.15h-.19l-.06.15h-.07l.23-.53h.07l.23.53Zm-.23-.2c-.02-.06-.04-.13-.08-.18l-.07.18h.15Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.15 43.75v-.34h.14l-.01.28c0 .18.05.22.16.22.14 0 .15-.14.15-.28l-.01-.22h.08v.3c0 .18-.1.25-.25.25s-.26-.05-.26-.2v-.01Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.53 43.54v-.07h-.15v-.06h.42v.07h-.14v.45h-.13v-.4Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.8 43.64c.05-.06.1-.15.14-.23h.08l-.18.3v.23h-.13v-.22l-.17-.31h.15l.12.23Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m25.56 40.85-.01 1c0 .6 0 .74.12.89.12.15.33.23.6.23.33 0 .58-.16.67-.4.03-.08.05-.2.05-.5 0-.51 0-1.01-.03-1.51h.37l-.02.18c-.02.33-.03 1.12-.04 1.5 0 .46-.14.67-.4.83a1.4 1.4 0 0 1-.67.16c-.47 0-1.04-.14-1.13-.74v-1.24c0-.2-.01-.5-.03-.69h.54l-.01.29h-.01Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.9 41.62v-.55l-.02-.5c.1.02.45.02.55 0a34.78 34.78 0 0 0-.03 2.37h.07c.12 0 .69 0 .92-.03a1 1 0 0 0 0 .28l-.76-.03-.75.03.03-1.05v-.53Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.49 42.67c0 .29.01.42.03.52a4.06 4.06 0 0 0-.57 0c.02-.3.04-.59.04-.88v-1.48h-.2c-.05 0-.43 0-.63.03a1.2 1.2 0 0 0 0-.3 19.08 19.08 0 0 0 2.12-.01 1.3 1.3 0 0 0 0 .31 7.56 7.56 0 0 0-.78-.03l-.01.43v1.41Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m32.82 42.77-.16-.4h-.98a8 8 0 0 0-.32.83h-.37l.46-.98a20 20 0 0 0 .72-1.65h.26c.19.5.43 1.03.57 1.35l.58 1.28h-.6l-.16-.43Zm-.65-1.57-.4.93.4.01h.38l-.38-.94Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.47 40.68c-.62.41-.98.94-.98 1.58 0 1.46 1.76 2.53 4.27 2.53a6 6 0 0 0 2.76-.65h-.05a8.9 8.9 0 0 1-2.56.36c-2.52 0-4.25-1.18-4.25-2.28 0-.6.28-1.13.81-1.5v-.04Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.28 40.56c.09 0 .16.06.16.15 0 .1-.07.17-.16.17a.16.16 0 0 1-.16-.17c0-.09.07-.15.16-.15Zm0 .29c.07 0 .13-.06.13-.14a.13.13 0 0 0-.13-.12.13.13 0 0 0-.13.12c0 .08.06.14.13.14Zm-.06-.23h.07c.04 0 .06.02.06.06 0 .03-.02.05-.04.05l.05.08h-.03l-.06-.08h-.03v.08h-.02v-.18Zm.02.09h.03s.05 0 .05-.03c0-.02-.02-.03-.04-.03h-.04v.06Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m39.22 41.13-.14.14-.14-.14a.95.95 0 0 0-.81-.27.94.94 0 0 0-.69.51l-.02.04a.96.96 0 0 0 .17 1.02l1.4 1.48c.04.05.12.05.17 0l1.38-1.45a.96.96 0 0 0 .17-1.09l-.02-.03a.93.93 0 0 0-1.47-.2v-.01Z",
    fill: "white"
  }));
};
var _default = exports.default = brandedcreditcardvertical;